import $ from 'jquery';

/**
 * Can be used only on places where jQuery is injected by the webpack otherwise versions will differ
 */
export default ({ _class, args }) => {
  let obj = null;

  if (typeof _class === 'function') {
    // Instantiating object
    if (args instanceof Array && args.length) {
      obj = new _class(...args);
    } else {
      obj = new _class();
    }

    // Passing jQuery
    if (obj instanceof _class && typeof obj.init === 'function') {
      obj.init($);
    }
  }

  return obj;
};



// WEBPACK FOOTER //
// ./vively/scripts/utils/class-loader.js